import { Button, Typography } from '@mui/material';
import { Chart, ArcElement, Tooltip, Legend, Title } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { RouteImage } from '../../assets/routeImage';
import HighchartsReact from 'highcharts-react-official';
import { useRef } from 'react';
import Highcharts from 'highcharts';
import exporting from 'highcharts/modules/exporting';

Chart.register(ArcElement, Tooltip, Legend, Title);
Chart.defaults.plugins.tooltip.backgroundColor = 'rgb(0, 0, 156)';
Chart.defaults.plugins.legend.position = 'bottom';
Chart.defaults.plugins.legend.title.display = true;

exporting(Highcharts)
Highcharts.setOptions({
    lang: {
        thousandsSep: ','
    }
});


type props = {
    className?: string;
    maxWidth?: string;
    heading: string;
    data: any;
    option: any;
    Doughnut?: boolean;
    enabled_line: boolean;
    valueSuffix?: string;
}

const BarChart = (props: props) => {
    const doughnutRef = useRef<any>(null);
    const options = {
        chart: {
            type: 'pie',
            //   width: 800,
            height: 500,
            // events: {
            //     render: function () {
            //         var chart: any = this,
            //             text = `ทั้งหมด<br/>  '0' โครงการ`,
            //             series = chart.series[0],
            //             x = chart.plotLeft + (series.center[0]),
            //             y = chart.plotTop + (series.center[1]),
            //             innerWidth = series.center[3],
            //             padding = 5,
            //             box;

            //         if (chart.pieCenter) {
            //             chart.pieCenter.destroy();
            //         }

            //         chart.pieCenter = chart.renderer
            //             .text(text, x, y, true)
            //             .css({
            //                 'text-align': 'center',
            //                 width: innerWidth - 2 * padding,
            //                 color: 'black',
            //                 whiteSpace: 'nowrap',
            //                 overflow: 'hidden',
            //                 'text-overflow': 'ellipsis',
            //             })
            //             .add();
            //         box = chart.pieCenter.getBBox();
            //         chart.pieCenter.attr({
            //             x: x - box.width / 2,
            //             y: y - box.height / 4
            //         });
            //     }
            // }
        },
        exporting: {
            // enabled: false,
            buttons: {
                contextButton: {
                    align: 'right',
                    verticalAlign: 'top',
                    x: -30,
                    y: 0
                },
                exportButton: {
                    align: 'left',
                    verticalAlign: 'top',
                    x: 0,
                    y: 0
                }
            }
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        // subtitle: {
        //     useHTML: true,
        //     text: `<div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
        //     <span style="font-size: 16px; font-weight: 500">ทั้งหมด </span><span style="font-size: 16px; font-weight: 500">${periodPlan?.data_all_status?.total || '0'} โครงการ</span></div>`,
        //     floating: true,
        //     verticalAlign: 'middle',
        //     align: 'center',
        //     y: 0,
        //     x: 30
        // },
        tooltip: {
            valueSuffix: props.valueSuffix ?? ' โครงการ',
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                innerSize: '50%',
                borderWidth: 2,
                cursor: 'pointer',
                showInLegend: true,
                dataLabels: {
                    formatter: function (this: any) {
                        return `<div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <span style="font-size:10px; font-weight: 300;">${this.key}</span>
                        <span style="font-size:16px; font-weight: 300;">${this.y.toLocaleString()}</span>
                        </div>`
                    },
                    enabled: true,
                    useHTML: true,
                }
            },
            credits: {
                enabled: false
            },
            series: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: [{
                    enabled: props.enabled_line,
                    distance: 5
                }, {
                    enabled: true,
                    distance: -40,
                    format: '{point.percentage:.1f}%',
                    style: {
                        fontSize: '0.8em',
                        textOutline: 'none',
                        opacity: 0.7,
                        color: "#fff"
                    },
                    filter: {
                        operator: '>',
                        property: 'percentage',
                        value: 10
                    }
                }]
            }
        },
        series: [
            {
                name: 'มี',
                // data: periodPlan?.data_all_status?.grouped?.map((items: any) => {
                //     return {
                //         name: items?.status_name,
                //         y: items?.amount,
                //     }
                // })
                data: props.data?.data_api?.length > 0 ? props.data?.data_api : [
                    { name: 'บรรจุแผน', y: 1620, color: '#FF6347' }, // red
                    { name: 'ได้รับจัดสรรงบประมาณ', y: 4713, color: '#1E90FF' }, // blue
                    { name: 'ระหว่างดำเนินการ', y: 1276, color: '#4169E1' }, // royalblue
                    { name: 'ดำเนินการแล้วเสร็จ', y: 1276, color: '#00CED1' }, // darkturquoise
                    { name: 'กันเงิน', y: 1276, color: '#9ACD32' }, // yellowgreen
                    { name: 'ยกเลิกโครงการ', y: 314, color: '#FFA500' }, // orange
                ],
            },
        ],
    };

    let optionsChart = {
        plugins: {
            legend: {
                display: true,
            },
        },
    };
    const isDataEmpty = !props.data || (Array.isArray(props.data.datasets) && props.data.datasets.every((dataset: any) => dataset.data.length === 0));

    return (
        <div className={`w-full max-w-[${props.maxWidth ? props.maxWidth : '317px'}] shadow-sm rounded-xl border-[1px] rounded-t-xl border-[#E5E5E7] flex flex-col ${props.className}`}>
            <span className='p-3 flex justify-between items-center border-[1px] rounded-t-xl border-[#E5E5E7]'>
                <Typography variant='h6'>
                    {props.heading}
                </Typography>
                {/* <Button sx={{ borderRadius: "10px" }} startIcon={<img src={RouteImage.dropdownDot} alt='icon' />}>

                </Button> */}
            </span>
            <span className='px-2 py-3'>
                {isDataEmpty ? (
                    <Typography className='text-center' variant='h6'>
                        {"ไม่พบข้อมูล"}
                    </Typography>
                ) : (
                    <>
                        {props.Doughnut ?
                            <>
                                <Doughnut options={optionsChart} data={props.data} />
                            </> :
                            <>
                                <HighchartsReact
                                    ref={doughnutRef}
                                    highcharts={Highcharts}
                                    options={options}
                                />
                            </>}




                    </>
                )}
            </span>
        </div>
    );
}

export default BarChart;